
import { useEffect } from "react";
import { JobFormData } from "../types/jobTypes";

/**
 * Hook for handling language data synchronization
 */
export const useJobFormData = (
  jobData: JobFormData,
  setSelectedLanguages: React.Dispatch<React.SetStateAction<string[]>>,
  setShowOtherLanguageField: React.Dispatch<React.SetStateAction<boolean>>
) => {
  // Update selected languages whenever languageRequirements changes
  useEffect(() => {
    if (jobData.languageRequirements) {
      const languages = (Array.isArray(jobData.languageRequirements)) ? jobData.languageRequirements : jobData.languageRequirements.split(',').map(lang => lang.trim());
      setSelectedLanguages(languages);
      setShowOtherLanguageField(languages.includes("Other"));
    }
  }, [jobData.languageRequirements, setSelectedLanguages, setShowOtherLanguageField]);
};
